import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../../../core/domain/events/domain_event_provider';
import { NutritionEvent } from './nutrition_events';

@Injectable({ providedIn: 'root' })
export class NutritionEventProvider extends DomainEventProvider<NutritionEvent> {}
